import React, { useContext, useState } from "react";
import { DATE_FORMAT_DISPLAY, POPUP_SMALL } from "../../constants";
import { BasePopupContext } from "../../hooks/usePopup";
import Cancel from "./Cancel";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { set_sidebar } from "../../redux/slices/uiSlice";
import { GrDownload } from "react-icons/gr";
import useApi from "../../hooks/useApi";
import axios from "axios";
import { customStringify, error_alert } from "../../utils";
import { network_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import { BiLoaderAlt } from "react-icons/bi";

const Container = ({ data }) => {
  const { subscription, free_subscription } = data;
  const isFreeSubscription = free_subscription.is_paid === "free";
  const { plan_detail, status, remaining_days, current_period_start,current_period_end ,can_cancel_ } = isFreeSubscription ? free_subscription : subscription;
  const { setPopup } = useContext(BasePopupContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Axios } = useApi();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();

  const handleCancel = (e) => {
    e.stopPropagation();
    setPopup({
      heading: <FormattedMessage id="cancel_subscription" defaultMessage={"Cancel Subscription"} />,
      component: <Cancel data={data.subscription} />,
      size: POPUP_SMALL,
    });
  };

  const handleInvoice = async () => {
    try {
      setLoading(true);
      const result = await Axios.get(`api/user/subscription-invoice/${data?.subscription?.latest_invoice}`);
      window.open(result.data.payload.pdf_link);
    } catch (e) {
      setLoading(false);
      if (axios.isCancel(e)) {
      } else if (e.response) {
        error_alert(customStringify(e.response.data.description));
      } else {
        error_alert(network_tl(intl));
      }
    }
    setLoading(false);
  };

  return (
    <div className="container bg-content-bg rounded-lg p-6 my-4 mx-auto max-w-xl">
      <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
        {isFreeSubscription ? <FormattedMessage id="free_plan" defaultMessage="Free Plan" /> : plan_detail.name}
      </h2>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-center">
        {isFreeSubscription ? (
          <>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="start_date" defaultMessage="Start Date" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">
                {DateTime.fromISO(free_subscription.free_start_date).toFormat(DATE_FORMAT_DISPLAY)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="end_date" defaultMessage="End Date" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">
                {DateTime.fromISO(free_subscription.free_end_date).toFormat(DATE_FORMAT_DISPLAY)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="remaining_days" defaultMessage="Remaining Days" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">{remaining_days} {remaining_days > 1 ? <FormattedMessage id="days" defaultMessage="days" /> : <FormattedMessage id="day" defaultMessage="day" />}</p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="subscription_plan" defaultMessage="Subscription Plan" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">
                {free_subscription.is_paid === "free" ? "Free" : "Paid"}
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="status" defaultMessage="Status" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800 capitalize">
                {status === "canceled" ? "Cancelled" : status}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="start_date" defaultMessage="Start Date" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">
                {DateTime.fromISO(current_period_start).toFormat(DATE_FORMAT_DISPLAY)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="end_date" defaultMessage="End Date" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">
              {DateTime.fromISO(current_period_end).toFormat(DATE_FORMAT_DISPLAY)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
              <FormattedMessage id="remaining_days" defaultMessage="Remaining Days" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">{remaining_days} {remaining_days > 1 ? <FormattedMessage id="days" defaultMessage="days" /> : <FormattedMessage id="day" defaultMessage="day" />}</p>
            </div>
            {/* <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-xs sm:text-sm text-gray-500">
                <FormattedMessage id="billing_term" defaultMessage="Billing Term" />
              </p>
              <p className="text-md sm:text-xl font-semibold text-gray-800">{plan_detail.name}</p>
            </div> */}
            
          </>
        )}
      </div>

      <div className="w-full flex justify-center sm:justify-end gap-x-2">
        {!isFreeSubscription && (
          <button
            disabled={loading || data?.latest_invoice === null}
            onClick={handleInvoice}
            className={`btn btn-primary justify-items-end text-sm text-white mt-4`}
          >
            {loading ? (
              <BiLoaderAlt className="text-2xl mx-auto animate-spin text-white" />
            ) : (
              <p className="flex gap-2 items-center">
                <GrDownload />
                <FormattedMessage id="invoice" defaultMessage="Invoice" />
              </p>
            )}
          </button>
        )}
        {isFreeSubscription ? (
          <button
            onClick={() => { dispatch(set_sidebar(false)); navigate("/pricing") }}
            className={`btn btn-primary justify-items-end text-sm text-white mt-4`}
          >
            <FormattedMessage id="upgrade_plan" defaultMessage="Upgrade Plan" />
          </button>
        ) : status === "canceled" ? (
          <button
            onClick={() => { dispatch(set_sidebar(false)); navigate("/pricing") }}
            className={`btn btn-primary justify-items-end text-sm text-white mt-4`}
          >
            <FormattedMessage id="renew_plan" defaultMessage="Renew Plan" />
          </button>
        ) : (
          <button
            onClick={handleCancel}
            className={`btn justify-items-end text-sm text-white mt-4 ${can_cancel_ ? "bg-red-600 hover:bg-red-700 hover:-translate-y-1" : "bg-gray-200 cursor-not-allowed"
              }`}
            disabled={!can_cancel_}
          >
            <FormattedMessage id="cancel_plan" defaultMessage="Cancel Plan" />
          </button>
        )}
      </div>

      {!isFreeSubscription && !can_cancel_ && (
        <p className="mt-2 text-sm text-gray-600 text-center">
          <FormattedMessage id="cannot_cancel" defaultMessage="This plan cannot be cancelled at this time." />
        </p>
      )}
    </div>
  );
};

export default Container;